export default {
  title: 'Múi giờ',
  currentTime: 'Giờ hiện tại',
  pinned: 'Thường dùng',
  prev: 'Múi giờ trước',
  next: 'Múi giờ sau',
  confirm: 'Xác nhận',
  hint: 'Lăn chuột hoặc dùng phím mũi tên để chọn múi giờ; trang sẽ tải lại sau khi xác nhận',
  cities: {
    m720: 'Phía tây đường đổi ngày quốc tế',
    m660: 'Đảo Midway',
    m600: 'Hawaii',
    m540: 'Alaska',
    m480: 'Tijuana, Baja California, Giờ Thái Bình Dương (Mỹ và Canada)',
    m420: 'Arizona, Chihuahua, La Paz, Mazatlan, Giờ miền núi (Mỹ và Canada)',
    m360: 'Guadalajara, Mexico City, Monterrey, Saskatchewan, Trung Mỹ, Giờ miền Trung (Mỹ và Canada)',
    m300: 'Indiana (Đông), Bogota, Lima, Quito, Giờ miền Đông (Mỹ và Canada), Caracas',
    m240: 'Asuncion, Santiago, Georgetown, La Paz, San Juan, Manaus, Giờ Đại Tây Dương (Canada), Newfoundland',
    m180: 'Cayenne, Greenland, Buenos Aires, Brasilia, Montevideo',
    m120: 'Trung Đại Tây Dương',
    m60: 'Azores, Quần đảo Cape Verde',
    p0: 'Casablanca, Dublin, Edinburgh, Lisbon, Luân Đôn, Monrovia, Reykjavik, Giờ phối hợp quốc tế',
    p60: 'Amsterdam, Berlin, Bern, Roma, Stockholm, Vienna, Sarajevo, Skopje, Warszawa, Zagreb, Brussels, Copenhagen, Madrid, Paris, Belgrade, Bratislava, Budapest, Ljubljana, Praha, Tây Trung Phi',
    p120: 'Athens, Bucharest, Istanbul, Amman, Windhoek, Jerusalem, Cairo, Harare, Pretoria, Beirut, Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius, Minsk',
    p180: 'Kuwait, Riyadh, Tbilisi, Nairobi, Baghdad, Moskva, Saint Petersburg, Volgograd, Tehran',
    p240: 'Abu Dhabi, Muscat, Yerevan, Baku, Port Louis, Kabul',
    p300: 'Islamabad, Karachi, Yekaterinburg, Tashkent, Sri Jayawardenepura, Chennai, Kolkata, Mumbai, New Delhi, Kathmandu',
    p360: 'Astana, Dhaka, Almaty, Novosibirsk, Yangon',
    p420: 'Krasnoyarsk, Bangkok, Hà Nội, Jakarta',
    p480: 'Irkutsk, Ulaanbaatar, Kuala Lumpur, Singapore, Perth, Đài Bắc, Bắc Kinh, Trùng Khánh, Hồng Kông, Urumqi',
    p540: 'Seoul, Yakutsk, Osaka, Sapporo, Tokyo, Adelaide, Darwin',
    p600: 'Vladivostok, Canberra, Melbourne, Sydney, Guam, Port Moresby, Brisbane, Hobart',
    p660: 'Magadan, Quần đảo Solomon, New Caledonia',
    p720: 'Auckland, Wellington, Fiji, Quần đảo Marshall, Petropavlovsk-Kamchatsky',
    p780: 'Samoa, Nukualofa',
    p840: 'Kiritimati, Quần đảo Line'
  }
};
